/* Learning Bugs collection page: read more, live filters, drawer, show more */
(function () {
  var root = document.querySelector('[data-lbc]');
  if (!root) return;
  var sid = root.getAttribute('data-section');
  var ctrl = null;
  var priceTimer = null;

  function $(sel, el) { return (el || root).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
  function shop() { return $('[data-lbc-shop]'); }
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function withSection(url) {
    var u = new URL(url, location.href);
    u.searchParams.set('section_id', sid);
    return u.toString();
  }

  /* Read more */
  var desc = $('.lbc-desc');
  if (desc) {
    var txt = $('.lbc-desc__txt', desc);
    var btn = $('.lbc-desc__more', desc);
    var check = function () {
      if (desc.classList.contains('open')) return;
      var short = txt.scrollHeight <= txt.clientHeight + 4;
      btn.hidden = short;
      desc.classList.toggle('lbc-desc--short', short);
    };
    check();
    window.addEventListener('load', check);
    btn.addEventListener('click', function () {
      var open = desc.classList.toggle('open');
      btn.setAttribute('aria-expanded', open);
      btn.innerHTML = open ? '<b>Read Less</b>' : '… <b>Read More</b>';
    });
  }

  /* Drawer */
  function drawer(on) {
    var side = $('[data-lbc-side]');
    var scrim = $('.lbc-scrim');
    if (!side) return;
    side.classList.toggle('on', on);
    if (scrim) scrim.classList.toggle('on', on);
    document.documentElement.classList.toggle('lbc-lock', on);
    if (on) {
      var x = $('.lbc-side__x', side);
      if (x) x.focus();
    }
  }
  function drawerOpen() {
    var side = $('[data-lbc-side]');
    return !!(side && side.classList.contains('on'));
  }

  /* Build URL from the filter form + sort */
  function formUrl() {
    var p = new URLSearchParams();
    var form = $('[data-lbc-form]');
    if (form) {
      new FormData(form).forEach(function (v, k) {
        if (String(v).trim() !== '') p.append(k, v);
      });
    }
    var sort = $('[data-lbc-sort]');
    if (sort && !p.has('sort_by')) p.set('sort_by', sort.value);
    var q = p.toString();
    return location.pathname + (q ? '?' + q : '');
  }

  /* Load a new state of the product area */
  function load(url, push, after) {
    if (ctrl) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    var s = shop();
    var wasOpen = drawerOpen();
    var openMap = {};
    $$('details[data-key]', s).forEach(function (d) { openMap[d.getAttribute('data-key')] = d.open; });
    var allMap = {};
    $$('.lbc-f__g--all', s).forEach(function (g) {
      var d = g.closest('details[data-key]');
      if (d) allMap[d.getAttribute('data-key')] = true;
    });
    s.classList.add('is-loading');

    fetch(withSection(url), ctrl ? { signal: ctrl.signal } : {})
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = parse(html);
        var ns = doc.querySelector('[data-lbc-shop]');
        if (!ns) { location.href = url; return; }
        s.className = ns.className;
        s.innerHTML = ns.innerHTML;
        $$('details[data-key]', s).forEach(function (d) {
          var k = d.getAttribute('data-key');
          if (k in openMap) d.open = openMap[k];
          if (allMap[k]) {
            var g = $('.lbc-f__g', d);
            var b = $('[data-lbc-all]', d);
            if (g) g.classList.add('lbc-f__g--all');
            if (b) b.textContent = b.getAttribute('data-less');
          }
        });
        if (wasOpen) {
          var side = $('[data-lbc-side]');
          if (side) {
            side.style.transition = 'none';
            side.classList.add('on');
            side.offsetWidth;
            side.style.transition = '';
          }
        }
        if (push) history.pushState({ lbcUrl: url }, '', url);
        if (after) after();
        if (!wasOpen) {
          var top = s.getBoundingClientRect().top;
          if (top < 0) window.scrollTo({ top: window.scrollY + top - 90, behavior: 'smooth' });
        }
      })
      .catch(function (e) { if (!e || e.name !== 'AbortError') location.href = url; })
      .then(function () { s.classList.remove('is-loading'); });
  }

  /* Show more */
  function saveState() {
    var g = $('[data-lbc-grid]');
    var m = $('[data-lbc-morewrap]');
    if (!g || !m) return;
    try {
      var st = Object.assign({}, history.state || {}, { lbc: { url: location.href, grid: g.innerHTML, more: m.innerHTML } });
      history.replaceState(st, '', location.href);
    } catch (e) {}
  }
  function restoreState() {
    var st = history.state && history.state.lbc;
    if (!st || st.url !== location.href) return;
    var g = $('[data-lbc-grid]');
    var m = $('[data-lbc-morewrap]');
    if (g && m) { g.innerHTML = st.grid; m.innerHTML = st.more; }
  }
  function more(a) {
    a.classList.add('is-loading');
    a.textContent = 'Loading…';
    fetch(withSection(a.href))
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = parse(html);
        var g = $('[data-lbc-grid]');
        var ng = doc.querySelector('[data-lbc-grid]');
        var m = $('[data-lbc-morewrap]');
        var nm = doc.querySelector('[data-lbc-morewrap]');
        if (!g || !ng) { location.href = a.href; return; }
        var first = null;
        $$('.lbc-card', ng).forEach(function (c) {
          if (!first) first = c;
          g.appendChild(c);
        });
        if (m) m.innerHTML = nm ? nm.innerHTML : '';
        if (first) {
          var link = first.querySelector('.lbc-card__t a');
          if (link) link.focus({ preventScroll: true });
        }
        saveState();
      })
      .catch(function () { location.href = a.href; });
  }

  /* Events */
  root.addEventListener('click', function (e) {
    var t = e.target;
    var el;
    if ((el = t.closest('[data-lbc-more]'))) { e.preventDefault(); more(el); return; }
    if ((el = t.closest('a[data-lbc-link]'))) { e.preventDefault(); load(el.getAttribute('href'), true); return; }
    if (t.closest('[data-lbc-open]')) { e.preventDefault(); drawer(true); return; }
    if (t.closest('[data-lbc-close]')) { e.preventDefault(); drawer(false); return; }
    if ((el = t.closest('[data-lbc-all]'))) {
      var g = el.closest('.lbc-f__g');
      var on = g.classList.toggle('lbc-f__g--all');
      el.textContent = el.getAttribute(on ? 'data-less' : 'data-more');
    }
  });

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-lbc-sort]') || t.closest('[data-lbc-form]')) {
      clearTimeout(priceTimer);
      if (t.type === 'number') {
        priceTimer = setTimeout(function () { load(formUrl(), true); }, 500);
      } else {
        load(formUrl(), true);
      }
    }
  });

  root.addEventListener('submit', function (e) {
    if (!e.target.matches('[data-lbc-form]')) return;
    e.preventDefault();
    clearTimeout(priceTimer);
    load(formUrl(), true);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawerOpen()) drawer(false);
  });

  window.addEventListener('popstate', function () {
    drawer(false);
    load(location.href, false, restoreState);
  });

  restoreState();
})();


/* 28.09.26: sub-collection buttons (All Christmas Gifts, Stocking Fillers...)
   make it obvious the row scrolls: arrow buttons, a soft fade at the edge,
   and a small nudge the first time the row is seen in a visit. */
(function () {
  var navs = document.querySelectorAll('[data-lbc-subs]');
  if (!navs.length) return;
  var css = document.createElement('style');
  css.textContent =
    '.lbc-subs-w{position:relative}' +
    '.lbc .lbc-subs-w .lbc-subs{-webkit-mask-image:none;mask-image:none;scroll-behavior:smooth}' +
    '.lbc .lbc-subs-w.is-more .lbc-subs{-webkit-mask-image:linear-gradient(90deg,#000 calc(100% - 90px),transparent calc(100% - 20px));mask-image:linear-gradient(90deg,#000 calc(100% - 90px),transparent calc(100% - 20px))}' +
    '.lbc .lbc-subs-w.is-back .lbc-subs{-webkit-mask-image:linear-gradient(90deg,transparent 20px,#000 90px);mask-image:linear-gradient(90deg,transparent 20px,#000 90px)}' +
    '.lbc .lbc-subs-w.is-back.is-more .lbc-subs{-webkit-mask-image:linear-gradient(90deg,transparent 20px,#000 90px,#000 calc(100% - 90px),transparent calc(100% - 20px));mask-image:linear-gradient(90deg,transparent 20px,#000 90px,#000 calc(100% - 90px),transparent calc(100% - 20px))}' +
    '.lbc .lbc-subs-arr{position:absolute;top:4px;z-index:2;display:none;place-items:center;width:38px;height:38px;margin:0;padding:0;border:1px solid #E6E8E3;border-radius:50%;background:#fff;color:#4A6741;box-shadow:0 2px 10px rgba(42,42,42,.12);cursor:pointer;transition:background .2s,color .2s}' +
    '@media (hover:hover){.lbc .lbc-subs-arr:hover{background:#4A6741;color:#fff;border-color:#4A6741}}' +
    '.lbc .lbc-subs-arr svg{width:18px;height:18px;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}' +
    '.lbc .lbc-subs-arr--next{right:0}.lbc .lbc-subs-arr--prev{left:0}' +
    '.lbc .lbc-subs-w.is-more .lbc-subs-arr--next,.lbc .lbc-subs-w.is-back .lbc-subs-arr--prev{display:grid}' +
    '@media (max-width:680px){.lbc .lbc-subs-w .lbc-subs{margin-right:0;padding-right:0}}';
  document.head.appendChild(css);

  var arrow = function (d) {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + d + '"/></svg>';
  };

  navs.forEach(function (n) {
    if (n.parentNode.classList.contains('lbc-subs-w')) return;
    var w = document.createElement('div');
    w.className = 'lbc-subs-w';
    n.parentNode.insertBefore(w, n);
    w.appendChild(n);
    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'lbc-subs-arr lbc-subs-arr--prev';
    prev.setAttribute('aria-label', 'Scroll back');
    prev.innerHTML = arrow('M15 5l-7 7 7 7');
    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'lbc-subs-arr lbc-subs-arr--next';
    next.setAttribute('aria-label', 'See more');
    next.innerHTML = arrow('M9 5l7 7-7 7');
    w.appendChild(prev);
    w.appendChild(next);

    var update = function () {
      var max = n.scrollWidth - n.clientWidth;
      w.classList.toggle('is-more', max > 4 && n.scrollLeft < max - 4);
      w.classList.toggle('is-back', n.scrollLeft > 4);
    };
    n.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    next.addEventListener('click', function () { n.scrollBy({ left: n.clientWidth * 0.7 }); });
    prev.addEventListener('click', function () { n.scrollBy({ left: -n.clientWidth * 0.7 }); });
    update();

    var seen = false;
    try { seen = sessionStorage.getItem('lbcSubsNudge') === '1'; } catch (e) {}
    if (!seen && w.classList.contains('is-more') && n.scrollLeft < 5 &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      try { sessionStorage.setItem('lbcSubsNudge', '1'); } catch (e) {}
      setTimeout(function () {
        n.scrollTo({ left: 70 });
        setTimeout(function () { n.scrollTo({ left: 0 }); }, 700);
      }, 1000);
    }
  });
})();
